import React from 'react';
import VBControlEnd from './vbControlEnd';
import { CssToggle } from './vbCssComponents';

class VBToggle extends React.Component {
    constructor(props){
        super(props);
        this.state={
            checked: props.initial ? props.initial : false,
            error: null,
            hasBlurred: false,
            paddingRight: null,
        }
        this.controlEnd = React.createRef();
        this.input = React.createRef();
    }

    isControlled() {
        return this.props.checked !== undefined;
    }

    getChecked() {
        return this.isControlled() ? !!this.props.checked : !!this.state.checked;
    }

    componentDidMount(){
        //Update the padding on the input to allow any length of suffix
        this.setState({ paddingRight: this.controlEnd.current.getWidth() });
    }

    componentDidUpdate(prevProps) {
        if (!this.isControlled() && prevProps.initial !== this.props.initial) {
            this.setState({ checked: !!this.props.initial });
        }
    }

    onChange(e){
        const checked = e.target.checked;
        if (!this.isControlled()) {
            this.setState({ checked });
        }
        if(this.props.onChange){
            this.props.onChange(checked);
        }
    }

    onFocus(e){
        if(this.props.onFocus){
            this.props.onFocus(e);
        }
    }

    onBlur(e){
        let error = ""
        //If validation returns a string its an error message, if null the validation passed
        if(this.props.validation){
            error = this.props.validation(e.target.checked)
        }
        this.setState({
            error:error,
            hasBlurred:true
        });
        if(this.props.onBlur){
            this.props.onBlur(e);
        }
    }

    getCheckClass(){
        //Only show validation styling if the user has left the input and there is something to validate with
        if(this.props.error) { return " validation-failed"; }
        if(!this.props.validation || !this.state.hasBlurred) { return ""; }
        if(this.state.error) { return " validation-failed"; }
        if(this.getChecked()) { return " validation-ok"; }
        return "";
    }


    render() {
        return (
            <div>
                <div className="w-full inline-block relative">
                    <CssToggle>
                        <input
                            ref={this.input}
                            onChange={this.onChange.bind(this)}
                            onFocus={this.onFocus.bind(this)}
                            onBlur={this.onBlur.bind(this)}
                            checked={this.getChecked()}
                            className={'mr-1 '+this.props.inputClass+this.getCheckClass()}
                            style={Object.assign({paddingRight: this.state.paddingRight}, this.props.inputStyle)}
                            type={"checkbox"}
                            disabled={this.props.disabled}
                            required={this.props.required}
                        />
                        <div class="toggle-slider">
                            <div class="toggle-knob"></div>
                        </div>
                    </CssToggle>
                    <div className="inline-block ml-1" onClick={() => {this.input.current.focus()}}>
                        {this.props.label}
                    </div>
                    {/* this ads the suffix possibility and the ok/invalid checkbox */}
                    <VBControlEnd ref={this.controlEnd} icon={this.getCheckClass()}/>
                </div>
                <div className="supp-scarlet caption">
                    {this.props.error ? this.props.error : null}
                    {this.state.hasBlurred && !this.props.error ? this.state.error : null}
                </div>
            </div>
            
        );
    }
}

VBToggle.defaultProps = { inputClass: '' };

export default VBToggle;